import React from 'react'
import './contact.css'
import {AiOutlineMail} from 'react-icons/ai'
import {RiMessengerLine} from 'react-icons/ri'
import {BsWhatsapp} from 'react-icons/bs'
import { useRef } from 'react'
import emailjs from 'emailjs-com'

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_txk115t', 'template_fjwnbrl', form.current, 'Ce36BcZ56CkByjAIJ')

    e.target.reset()
  };

  return (
<section id='contact'>
  <h5>Get In Touch</h5>
  <h2>Contact Me</h2>

  <div className="container contact_container">
    <div className="contact_options">
      <article className='contact_option'>
      <AiOutlineMail className='contact_option-icon'/>
      <h4>Email</h4>
      <h5>Naeem78804@gmail.com</h5>
      <a href="mailto:naeem78804@gmail.com" target="_blank">Send a message</a>
      </article>

      <article className='contact_option'>
      <RiMessengerLine className='contact_option-icon'/>
      <h4>Messenger</h4>
      <h5></h5>
      {/* <h5>Naeem Khan</h5> */}
      <a href="https://m.me/ernest.achiever" target="_blank">Send a message</a>
      </article>

      <article className='contact_option'>
      <BsWhatsapp className='contact_option-icon'/>
      <h4>WhatsApp Contact</h4>
      <h5>+92 3409192279</h5>
      <a href="https://api.whatsapp.com/send?phone+923409192279" target="_blank">Send a message</a>
      </article>
    </div>
    {/* END OF CONTACT OPTIONS */}

    <form ref={form} onSubmit={sendEmail}>
      <input type="text" name='name' placeholder='Your Full Name' required />
      <input type="text" name="email" placeholder='Your Email' required />
      <textarea name="message" rows="7" placeholder='Your Message' required></textarea>
      <button type='submit' className='btn btn-primary'>Send Message</button>
    </form>
  </div>
</section>  
 )
}

export default Contact